import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import CloseImg from "Images/profile/close_icon.svg";
import "./drawer.scss";
import { useScreenWidth } from "../../SubscriptionPageV2/hooks";
/**
 * Single Drawer component
 */
const DrawerComponent = ({ children, anchor, open, crossButton, toggleDrawer, extraClassName, backdropClickToggle = true, drawerClassName, hideBackdrop = false, disableBackDropClick = false, hideZendeskIcon = false, }) => {
    const isMobile = useScreenWidth() < 968;
    const onClose = (_, reason) => {
        if (reason === "backdropClick" && disableBackDropClick) {
            return;
        }
        toggleDrawer(false)();
    };
    const anchorValue = isMobile ? "bottom" : "right";
    return (_jsxs(SwipeableDrawer, { PaperProps: {
            classes: {
                root: `drawer__content_wrapper drawer__content_wrapper_${anchor} ${drawerClassName ? drawerClassName : ""}`,
            },
        }, disableSwipeToOpen: true, disableDiscovery: true, anchor: anchor || anchorValue, 
        // @ts-ignore
        // types are outdated. This is the correct type
        onClose: onClose, onOpen: toggleDrawer(true), open: open, classes: {
            paperAnchorBottom: "drawer__content_wrapper__bottom",
        }, hideBackdrop: hideBackdrop, style: hideZendeskIcon ? { zIndex: 999999 } : {}, children: [crossButton && (_jsx("div", { className: `drawer_button_wrapper ${extraClassName}`, children: _jsx("button", { type: "button", className: "drawer_close_button", onClick: toggleDrawer(false), children: _jsx("img", { src: CloseImg, alt: "Close" }) }) })), _jsx("div", { className: "drawer__content", children: children })] }));
};
export default DrawerComponent;
